var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenWhats2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3676 19.9864L4.6706 20.4371C4.58771 20.451 4.50271 20.4448 4.42268 20.4192C4.34264 20.3935 4.26989 20.3492 4.21046 20.2897C4.15104 20.2303 4.10667 20.1576 4.08104 20.0775C4.05541 19.9975 4.04926 19.9125 4.0631 19.8296L4.5137 17.1325C3.24292 15.1574 2.74723 12.7823 3.12197 10.4639C3.4967 8.14542 4.7154 6.04738 6.54367 4.57326C8.37194 3.09914 10.6807 2.35303 13.0259 2.47843C15.3711 2.60383 17.5871 3.59188 19.2477 5.25256C20.9084 6.91323 21.8964 9.12926 22.0218 11.4744C22.1471 13.8196 21.401 16.1284 19.9268 17.9566C18.4527 19.7849 16.3546 21.0035 14.0362 21.3782C11.7177 21.7529 9.34261 21.2572 7.3676 19.9864Z",
    fill: "#00C451",
    stroke: "#00C451",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4267 10.9315C11.9636 11.8027 12.697 12.536 13.5681 13.0729L14.39 12.5798C14.565 12.4748 14.7679 12.4258 14.9716 12.4395C15.1752 12.4532 15.3698 12.5289 15.5292 12.6564L17.1243 13.9325C17.2347 14.0208 17.3251 14.1315 17.3896 14.2573C17.454 14.3831 17.4911 14.5211 17.4983 14.6623C17.5055 14.8035 17.4827 14.9446 17.4314 15.0763C17.3801 15.208 17.3015 15.3274 17.2007 15.4265L16.4796 16.1355C15.9972 16.6112 15.368 16.9097 14.6944 16.9823C14.0208 17.055 13.3425 16.8976 12.7697 16.5358C10.846 15.2916 9.20809 13.6536 7.96389 11.73C7.60203 11.1572 7.44464 10.4788 7.51732 9.80522C7.59 9.13162 7.88848 8.50243 8.36419 8.02002L9.07319 7.29891C9.17229 7.19811 9.29164 7.11947 9.42336 7.06817C9.55507 7.01688 9.69617 6.99409 9.83734 7.00131C9.97851 7.00853 10.1165 7.04559 10.2423 7.11006C10.3681 7.17453 10.4788 7.26494 10.5671 7.37532L11.8432 8.97044C11.9707 9.12981 12.0464 9.32438 12.0601 9.52802C12.0738 9.73165 12.0249 9.93461 11.9198 10.1096L11.4267 10.9315Z",
    fill: "white",
    stroke: "#00C451",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenWhats2);
export default __webpack_public_path__ + "static/media/green-whats-2.1bebfb47e9642635f035605a3a132069.svg";
export { ForwardRef as ReactComponent };